import {CountUp} from "countup.js"

const COUNTING_NUMBERS = document.querySelectorAll(".counting-number [data-to]")
const DURATION_IN_SECONDS = 2

const START_ANIMATE_NUMBER = (numberItem, DURATION_IN_SECONDS) => {
  let aimValue = parseInt(numberItem.dataset.to)
  const COUNTER = new CountUp(numberItem, aimValue, {
    duration: DURATION_IN_SECONDS,
    startVal: parseInt(numberItem.dataset.from),
    separator: ".",
    useGrouping: true,
    enableScrollSpy: true,
    scrollSpyOnce: true
  })

  if (COUNTER.error) console.error(COUNTER.error)
}

export const INIT_COUNT_UP = () => {
  COUNTING_NUMBERS.forEach(numberItem => START_ANIMATE_NUMBER(numberItem, DURATION_IN_SECONDS))
}
